import React, { useState, useMemo, useCallback, useEffect } from 'react';
import styled from 'styled-components';

import { Checkbox, CheckedState } from '@ge/components/checkbox';
import { killEventPropagation } from '@ge/shared/util';

const StyledCheckbox = styled.div`
  &.disabled {
    opacity: 0.3;
    cursor: not-allowed;
    pointer-events: none;
  }
  label {
    display: inline-block;
    margin-top: 2px;
  }
  span {
    margin-left: 0;
  }
`;

const ID = 'id';

export const useExistingGamageDetailsTable = ({ data, maxSelectionLimit: MAX_SELECTION_LIMIT }) => {
  const [checkedRows, setCheckedRows] = useState([]);

  const rows = useMemo(
    () => (data.length > MAX_SELECTION_LIMIT ? data.slice(0, MAX_SELECTION_LIMIT) : data),
    [MAX_SELECTION_LIMIT, data],
  );

  const renderCheckbox = useCallback(
    (id) => {
      return (
        <StyledCheckbox
          onClick={(e) => {
            killEventPropagation(e);
            e.preventDefault();

            if (checkedRows.includes(id)) {
              setCheckedRows(checkedRows.filter((row) => row !== id));
            } else if (checkedRows.length < rows.length) {
              setCheckedRows([...checkedRows, id]);
            }
          }}
          className={
            checkedRows.length >= rows.length && !checkedRows.includes(id) ? 'disabled' : ''
          }
        >
          <Checkbox
            checkState={checkedRows.includes(id) ? CheckedState.CHECKED : CheckedState.UNCHECKED}
            label={''}
          />
        </StyledCheckbox>
      );
    },
    [checkedRows, rows],
  );

  useEffect(
    () => setCheckedRows((prev) => prev.filter((id) => rows.find((row) => row[ID] === id))),
    [rows],
  );

  return useMemo(
    () => ({
      checkedRows,
      renderCheckbox,
    }),
    [checkedRows, renderCheckbox],
  );
};
